import { Entity } from '@/store/shared/entity'
import { DeclarationElementProductDto } from "./productelement"
export default class CopyProductElement extends Entity<number>{

  shippingNumber: string;

  index: number;
  // 清单
  declarationElementProductDtoList: Array<CopyDeclarationElementProduct> = new Array<CopyDeclarationElementProduct>();

  declarationElementProductDto: DeclarationElementProductDto;
}

export class CopyDeclarationElementProduct extends DeclarationElementProductDto {
  isCopy: boolean;
}